export default {"src":"/_next/static/media/IconDririder.3dd5aae6.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};